import React, { FC, useContext, useState, useCallback, useEffect } from 'react'
import { MenuActive } from '@modules/practitioner/practitioner-module'
import { useTranslation } from 'react-i18next'
// import BulletsDevices from '@modules/devices/components/Bullets'
import HostList from '@modules/devices/components/host/HostList'
import HostForm from '@modules/devices/components/host/HostForm'
import SwitchDeviceComponents from '@modules/devices/SwitchDeviceComponents'
import DevicesScreen from '@modules/devices/DevicesScreen'

// import BulletList from '@components/bullets/bullet-list'

import { deleteHosts/*, getHostsByOrganizationId*/ } from '@services/device/host'
import Host from '@interfaces/device/host'
import Bullet from '@interfaces/bullet/bullet'
// import BackTitlePrimary from "@components/back-buttons/back-title-primary"

import { useSelector } from 'react-redux'
import { RootState } from '@redux/store'
// import logger from '@functions/logger'
import { notify } from '@functions/notification'
import useRestricByPlanType from '@customHooks/restricted-routes/use-restrict-by-plan-type'
import { PlanModule } from '@interfaces/permission_access'
// import { useNavigate } from 'react-router-dom';

const HostScreen:FC = () => {
  // const history = useNavigate();
  const { setMenuActive } = useContext(MenuActive)
  const { t } = useTranslation(['myDevices', 'ordinalNumbers'])
  const session = useSelector((state: RootState) => state.session)
  useRestricByPlanType(PlanModule.TELEMEDICINE)

  const [isReady, setIsReady] = useState<boolean>(false)

  const [organizationHostId, setOrganizationHostId] = useState<string>('')

  const [hosts, setHosts] = useState<Host[]>([])

  const [hostEdit, setHostEdit] = useState<Host>()

  const [hostToDevice, setHostToDevice] = useState<Host>()

  const [isEditing, setIsEditing] = useState(false)

  /* const range = (n: number) => Array.from(Array(n).keys())

  range(103).forEach((element) => {
    const ordinalConstants = number2Ordinal(element)
    const label = ordinalConstants.length > 1 ?
                  t("ordinalNumbers:" + ordinalConstants[0]) + " - " + t("ordinalNumbers:" + ordinalConstants[1]) :
                  t("ordinalNumbers:" + ordinalConstants[0])
    console.log("element: " , element, " - " , label)
  } )
*/

  const initBullet: Bullet = {
    code: 'Inicio',
    isActive: false,
    change: () => ({})
}

  const [bullets, setBullets] = useState<Bullet[]>([initBullet])


  const [activeComponent, setActiveComponent] = useState<string>("hostList")


  const hostListBullet = useCallback(() => {
    const updatedBullets: Bullet[] = [{
                                      code: t("breadcrums.host.start"),
                                      isActive: false,
                                      change: () => ({})
                                  },{
                                code: t("breadcrums.host.hostList"),
                                isActive: true,
                                change: () => ({})
                              }]

    setBullets( updatedBullets )

  }, [setBullets,t])

  const hostFormBullet = useCallback(() => {
    const updatedBullets: Bullet[] = [{
                                      code: t("breadcrums.host.start"),
                                      isActive: false,
                                      change: () => ({})
                                  },{
                                code: t("breadcrums.host.hostList"),
                                isActive: false,
                                change: () => setActiveComponent("hostList")
                              },
                              {
                                code: t("breadcrums.host.hostForm"),
                                isActive: true,
                                change: () => ({})
                              }]
    setBullets(updatedBullets)

  }, [setBullets,t])

  const deviceScreenBullet = useCallback(() => {
    const updatedBullets: Bullet[] = [{
                                      code: t("breadcrums.host.start"),
                                      isActive: false,
                                      change: () => ({})
                                  },{
                                code: t("breadcrums.host.hostList"),
                                isActive: false,
                                change: () => setActiveComponent("hostList")
                              },
                              {
                                code: t("breadcrums.devices.devicesScreen"),
                                isActive: true,
                                change: () => ({})
                              }]
    setBullets(updatedBullets)

  }, [setBullets,t])

  const setHostToEdit = (host?: Host) => {
    setHostEdit(host);
    setIsEditing(true);
    setActiveComponent('hostForm');
    //toggleShowForm();
  }

  const deleteHost = async(id: string) => {
    // console.log("Device to be deleted: " + id)
    const filteredHosts = hosts.filter(host => host.deviceHostId !== id);
    setHosts(filteredHosts)
    try {
      const answer = await deleteHosts(id)
      if(answer){
        notify({ message: t('notify.deleteHostSuccess'), messageType: 'success' });
      }
    } catch (error) {
      notify({ message: t('notify.deleteHostError'), messageType: 'error' });
    }
  }

  useEffect(() => {
    setMenuActive('devices');
}, [setMenuActive]);

  return (
    <div className="card-primary hosts">
      {/* <BulletList bullets={bullets} /> */}
        {/* <div className="Services__Title">{t('title')}</div> */}
        {/* <BackTitlePrimary titleText={t('title')} backAction={() => history(-1)}/> */}

        <SwitchDeviceComponents activeComponentName={activeComponent}>

          <HostList name="hostList" hosts={hosts}
                    setHosts={setHosts}
                    changeComponent={(componentName: string) => setActiveComponent(componentName)}
                    setBullets={hostListBullet}
                    deleteHost={deleteHost}
                    setOrganizationHostId={setOrganizationHostId}
                    setHostEdit={setHostToEdit}
                    setHostToDevice={setHostToDevice}/>

          <HostForm name="hostForm"
                    changeComponent={() => setActiveComponent("hostList")}
                    setBullets={hostFormBullet}
                    isEditing={isEditing}
                    setEditing={setIsEditing}
                    hostToEdit={hostEdit} />

          <DevicesScreen  name="devicesScreen"
                          changeComponent={() => setActiveComponent("devices.devicesScreen")}
                          setBullets={deviceScreenBullet}
                          organizationHostId={organizationHostId}
                          hostToDevice={hostToDevice}/>

        </SwitchDeviceComponents>
    </div>
  );
};

export default HostScreen
